module.exports = __webpack_public_path__ + "static/media/Lab_Partner_5_PCR_Product.894b8b98.svg";